import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

/** Wrapper that checks for admin role, redirects to Dashboard if not admin */
export function AdminGuard({ children }: { children: React.ReactNode }): React.JSX.Element {
  const { roles } = useAuth();
  const isAdmin = roles.includes('admin');

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
